import * as React from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { getProductBlockDisplayDetails } from '@grandvisionhq/fun-search';
import { useVariantSwitcher, ProductBlock } from '@grandvisionhq/lib-visuals';
import '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import { pushVariantClickEvent } from '../../DataLayer/Events/VariantSwitcherEvents.js';
import { useProductLink } from '../../utils/use-product-link.js';

const ProductListingBlock = ({ className , listingProduct , reimbursableLogos , tabIndex , productLocation , onImpression , onInteraction ,  })=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const variants = [
        listingProduct.masterVariant,
        ...listingProduct.variants
    ];
    const { activeSku , activeVariant , handleVariantChange  } = useVariantSwitcher({
        variants,
        initialSku: listingProduct.masterVariant.sku
    });
    const link = useProductLink(listingProduct.slug, activeSku, listingProduct.productType);
    const { wasSeen , ref: ref6  } = useWasSeenByUser();
    React.useEffect(()=>{
        if (wasSeen && onImpression) {
            onImpression();
        }
    }, [
        onImpression,
        wasSeen
    ]);
    const onVariantChange = (sku)=>{
        const selectedVariant = variants.find((variant)=>variant.sku === sku
        );
        if (selectedVariant) {
            pushVariantClickEvent(selectedVariant, listingProduct.productType);
        }
        handleVariantChange(sku);
    };
    if (!activeVariant) return null;
    const frontImage = (ref = activeVariant.images) === null || ref === void 0 ? void 0 : ref[0];
    const angleImage = (ref1 = activeVariant.images) === null || ref1 === void 0 ? void 0 : ref1[1];
    const displayDetails = getProductBlockDisplayDetails({
        product: listingProduct,
        variant: activeVariant
    });
    return /*#__PURE__*/ React.createElement(ProductBlock.Outer, {
        className: className,
        ref: ref6
    }, /*#__PURE__*/ React.createElement(ProductBlock.Inner, null, /*#__PURE__*/ React.createElement(ProductBlock.Header, null, /*#__PURE__*/ React.createElement(ProductBlock.Header.Left, {
        tag: activeVariant.tag,
        isProductReimbursable: activeVariant.isInsuranceReimbursable,
        defaultReimbursableLogo: reimbursableLogos === null || reimbursableLogos === void 0 ? void 0 : reimbursableLogos.default,
        alternativeReimbursableLogo: reimbursableLogos === null || reimbursableLogos === void 0 ? void 0 : reimbursableLogos.alternative
    }), /*#__PURE__*/ React.createElement(ProductBlock.Header.Right, {
        sku: activeVariant.sku,
        tabIndex: tabIndex,
        productLocation: productLocation
    })), /*#__PURE__*/ React.createElement(ProductBlock.Details, {
        href: link,
        onClick: onInteraction,
        tabIndex: tabIndex
    }, /*#__PURE__*/ React.createElement(ProductBlock.Details.Heading, null, displayDetails.heading), /*#__PURE__*/ React.createElement(ProductBlock.Details.Caption, null, displayDetails.caption)), /*#__PURE__*/ React.createElement(ProductBlock.Images, {
        href: link,
        onClick: onInteraction,
        frontUrl: (frontImage === null || frontImage === void 0 ? void 0 : frontImage.url) || '',
        frontAlt: frontImage === null || frontImage === void 0 ? void 0 : frontImage.altTag,
        angleUrl: angleImage === null || angleImage === void 0 ? void 0 : angleImage.url
    }), /*#__PURE__*/ React.createElement(ProductBlock.Pricing, {
        originalPrice: activeVariant.pricing.price.originalPrice,
        discountedPrice: (ref2 = activeVariant.pricing.price.discount) === null || ref2 === void 0 ? void 0 : ref2.price,
        discountLabel: (ref3 = activeVariant.pricing.price.discount) === null || ref3 === void 0 ? void 0 : ref3.description,
        discountValue: (ref4 = activeVariant.pricing.price.discount) === null || ref4 === void 0 ? void 0 : ref4.badge,
        bestPrice: activeVariant.pricing.bestPrice,
        pricePerUnit: (ref5 = activeVariant.pricing.pricePerUnit) === null || ref5 === void 0 ? void 0 : ref5.amount,
        currency: activeVariant.pricing.price.currencyCode,
        isCentAmount: activeVariant.pricing.price.isCentAmount
    }), /*#__PURE__*/ React.createElement(ProductBlock.Footer, null, /*#__PURE__*/ React.createElement(ProductBlock.Footer.Variants, {
        variants: variants,
        activeSku: activeSku,
        onVariantChange: onVariantChange,
        tabIndex: tabIndex
    }))));
};

export { ProductListingBlock };
//# sourceMappingURL=ProductListingBlock.js.map
